import clsx from 'clsx';
import React from 'react';
import { useHistory } from 'react-router';
import { withStyles } from '@material-ui/core';

import styles from './style';
import Header from '../../Header';
import Box from '../../atomic/Box';
import Container from '../../Container';
import Typography from '../../atomic/Typography';
import useDesktop from '../../../hooks/useDesktop';
import LinearProgress from '../../atomic/LinearProgress';

const Page = ({
  classes,
  children,
  className,
  headerTitle,
  contentClass,
  noPaddingTop,
  root = false,
  maxWidth = 'md',
  onMenuIconClick,
  onEditIconClick,
  headerPosition,
  fullPage = false,
  backButtonAction,
  noPadding = false,
  hideHeader = false,
  upperHeader = null,
  headerLeftChildren,
  safePaddingEnabled,
  headerBorder = false,
  headerContextButtons,
  minFullHeight = false,
  showBackButton = true,
  showProgressBar = false,
  progressBarText = 'Oppdaterer...',
  lessMarginLeft,
  ...props
}) => {
  const history = useHistory();
  const isDesktop = useDesktop();

  const onBackButtonAction = backButtonAction || history.goBack;
  const onBackButtonClick = showBackButton ? onBackButtonAction : null;

  return (
    <div
      className={clsx(
        className,
        classes.container,
        root && classes.root,
        minFullHeight && classes.minFullHeight
      )}
    >
      <Header
        className={classes.marginLeftZero}
        hidden={hideHeader}
        fullPage={fullPage}
        position={headerPosition}
        upperHeader={upperHeader}
        bottomBorder={headerBorder}
        maxWidth={!root && maxWidth}
        leftChildren={headerLeftChildren}
        onMenuIconClick={onMenuIconClick}
        onEditIconClick={onEditIconClick}
        onBackButtonClick={onBackButtonClick}
        contextButtons={headerContextButtons}
      >
        <div {...props}>
          {(headerTitle || typeof headerTitle === 'string') && (
            <Typography
              className={classes.title}
              variant={isDesktop && !fullPage ? 'h1' : 'h3'}
              color={isDesktop && !fullPage ? undefined : 'textPrimary'}
            >
              {headerTitle}
            </Typography>
          )}
        </div>
      </Header>

      {showProgressBar && (
        <>
          <LinearProgress />
          <Box pr={1} textAlign="right">
            <Typography component="small" color="textSecondary">
              {progressBarText}
            </Typography>
          </Box>
        </>
      )}

      <Container
        maxWidth={maxWidth}
        disableGutters={noPadding}
        className={clsx(contentClass, classes.content)}
      >
        {children}
      </Container>
    </div>
  );
};

export default withStyles(styles)(Page);
